import { isWaybetterProduct } from '../../../lib/utils';

export { query } from './query';

/**
 * The definition of joinability can vary depending on the point of view.
 * For example, game services consider games _not_ joinable if the user
 * does not have a membership. Yet the game *is* considered joinable because
 * the user can add the membership, then join the game, so therefore, the game
 * is potentially joinable.
 *
 * @param {object} game - The game to check joinability on.
 * @returns {object} - An object representing all of the facets of joinability.
 */
export function checkJoinability(game) {
  const membershipOfferId = isWaybetterProduct(game.gameType)
    ? null
    : game.membershipOffer?.id;

  // The game service includes user membership detection in order to
  // determine joinability. It will be false for authenticated users
  // who are not members.
  // Also, the game service will return false if a member-only game is
  // not joinable because a user is not a member yet.
  const joinable = !!game.joinability?.joinable;

  // Member only games should be joinable even if a user is not a member.
  // The joinability flag will return false but we still want to allow
  // the button to be clickable.
  const dependsOnMembership =
    !joinable &&
    ['membershipRequired', 'dietbetMembershipRequired'].includes(
      game.joinability?.code
    );

  const potentiallyJoinable = joinable || dependsOnMembership;

  return {
    code: game.joinability?.code,
    potentiallyJoinable,
    dependsOnMembership,
    membershipOfferId,
  };
}
